import { useAtomValue, useUpdateAtom } from "jotai/utils"

import { atom } from "jotai"
import { useEffect } from "react"

const lockedRow = atom<string | undefined>(undefined)

export function useLockedRow() {
  const value = useAtomValue(lockedRow)
  const updateValue = useUpdateAtom(lockedRow)

  const update = (id: string | undefined) => updateValue(id)

  useEffect(() => {
    return () => {
      updateValue(undefined)
    }
  }, [updateValue])

  return { value, update }
}
